const messages = {
    accountBox: {
        title: "Dashboard",
        description: "Verfolgen Sie Ihre Aktionen und Punkte auf einen Blick.",
        button: "DASHBOARD ÖFFNEN",
    },
};

export default {
    messages,
};
